import { HoneygridMarkerIcon } from '@/icons'
import { useEffect, useRef, useState } from 'react'
import { Marker, Popup } from 'react-map-gl/mapbox'

import type { FC, PropsWithChildren } from 'react'

interface PopupLocationMarkerProps extends PropsWithChildren {
	openPopup?: boolean
	coordinates: {
		latitude: number
		longitude: number
	}
}

export const PopupLocationMarker: FC<PopupLocationMarkerProps> = ({
	children,
	coordinates,
	openPopup = false,
}) => {
	const [popupOpen, setPopupOpen] = useState(openPopup)
	const hideTimeoutRef = useRef<NodeJS.Timeout | null>(null)

	useEffect(() => {
		return () => {
			if (hideTimeoutRef.current) {
				clearTimeout(hideTimeoutRef.current)
			}
		}
	}, [])

	useEffect(() => {
		setPopupOpen(openPopup)
	}, [openPopup])

	const handleMouseEnter = () => {
		if (hideTimeoutRef.current) {
			clearTimeout(hideTimeoutRef.current)
			hideTimeoutRef.current = null
		}
		setPopupOpen(true)
	}

	const handleMouseLeave = () => {
		// Add a small delay before hiding to allow moving to popup
		hideTimeoutRef.current = setTimeout(() => {
			setPopupOpen(false)
		}, 100)
	}

	return (
		<>
			<Marker {...coordinates}>
				<div
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
				>
					<HoneygridMarkerIcon fontSize="large" color="primary" />
				</div>
			</Marker>
			{popupOpen ? (
				<Popup
					{...coordinates}
					anchor="bottom"
					style={{
						padding: 0,
						borderRadius: '25px',
					}}
					closeButton={false}
					maxWidth="300px"
					closeOnClick={false}
					offset={20}
				>
					<div
						onMouseEnter={handleMouseEnter}
						onMouseLeave={handleMouseLeave}
					>
						{children}
					</div>
				</Popup>
			) : null}
		</>
	)
}
